import * as React from "react";

import RentalIncomeSection from "./RentalIncomeSection";

const { Panel } = require("react-bootstrap");

interface IRentalIncomeProps {
  rentalProperties: any;
  setOwnedRealEstateScheduleEPropertyLabel: Function;
  propertyLabelAndAddressOptions: Function;
  propertyLabelAndAddressOptionSelected: Function;
  setDocId: Function;
  getDocsForOwner: Function;
  taxReturns: any[];
  handleChange: Function;
}

class RentalIncome extends React.Component<IRentalIncomeProps, any> {
  handleRentalIncomeChange(index, prop, value) {
    this.props.handleChange(index, prop, value);
  }

  render() {
    const {
      rentalProperties,
      taxReturns,
      setOwnedRealEstateScheduleEPropertyLabel,
      propertyLabelAndAddressOptions,
      propertyLabelAndAddressOptionSelected,
      setDocId,
      getDocsForOwner,
    } = this.props;
    return (
      <Panel defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>Disclosed Rental Income</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {rentalProperties.map((property, i) => (
              <RentalIncomeSection
                key={i}
                ownedDocs={getDocsForOwner(property.id)}
                taxReturns={taxReturns}
                property={property}
                setOwnedRealEstateScheduleEPropertyLabel={setOwnedRealEstateScheduleEPropertyLabel}
                propertyLabelAndAddressOptions={propertyLabelAndAddressOptions}
                propertyLabelAndAddressOptionSelected={propertyLabelAndAddressOptionSelected}
                setDocId={setDocId}
                onChange={this.handleRentalIncomeChange.bind(this, i)}
              />
            ))}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default RentalIncome;
